const logosWrappers = document.querySelectorAll('.logos-images')

if (logosWrappers) {
  logosWrappers.forEach(logosWrapper => {

    const autoScroll = logosWrapper.dataset.autoscroll

    var slider = tns({
      autoplay: autoScroll,
      autoplayButton: false,
      autoplayButtonOutput: false,
      container: logosWrapper,
      arrowKeys: true,
      items: 3,
      slideBy: 1,
      speed: 1000,
      autoplayTimeout: 3000,
      mouseDrag: true,
      nav: false,

      controls: true,
      controlsPosition: "bottom",
      controlsText: ["", ""],
      responsive: {
        768: {
          items: 5
        },
        990: {
          items: 6
        },

      }
    });
  });
}
